export function MarkdownView({ html }: { html: string }) {
  return <div className="chat-md text-sm" dangerouslySetInnerHTML={{ __html: html }} />;
}
